import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import { adminPlanAddonApi } from '../../api/adminSubscriptionPlan.api';
import { apiHandler, unwrapData } from '../../utils/apiHandler';
import { formatMoney } from './planFormatters';
import './subscription-plans.css';

export default function PlanAddonList() {
  const navigate = useNavigate();
  const [addons, setAddons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = async () => {
    setLoading(true);
    const result = await apiHandler(() => adminPlanAddonApi.list());
    if (result.success) {
      setAddons(unwrapData(result) || []);
    } else {
      setError(result.message || 'Failed to load add-ons');
    }
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="sp-page">
      <PageHeader
        title="Plan Add-ons"
        subtitle="Optional add-ons shown on the billing page"
        actions={(
          <button type="button" className="sp-btn sp-btn-primary" onClick={() => navigate('/plan-addons/new/edit')}>
            <i className="fa-solid fa-plus" /> Create add-on
          </button>
        )}
      />

      {error && <div className="sp-alert sp-alert-danger">{error}</div>}

      {loading && (
        <div className="sp-loading">
          <i className="fa-solid fa-spinner fa-spin" /> Loading add-ons...
        </div>
      )}

      {!loading && addons.length === 0 && (
        <div className="sp-empty">
          <div><i className="fa-solid fa-puzzle-piece" /></div>
          <p>No add-ons yet. Create your first optional add-on.</p>
        </div>
      )}

      {!loading && addons.length > 0 && (
        <div className="sp-addon-grid">
          {addons.map((addon) => (
            <article key={addon.id} className="sp-addon-card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                <h3>{addon.name}</h3>
                {addon.isFutureRelease && (
                  <span className="sp-badge sp-badge-future">Future Release</span>
                )}
              </div>
              <span className="sp-addon-code">{addon.code}</span>
              {addon.description && (
                <p style={{ margin: 0, fontSize: 13, color: '#64748b', lineHeight: 1.5 }}>{addon.description}</p>
              )}
              <div className="sp-addon-price">
                {formatMoney(addon.price)}
                <small> / {addon.interval}</small>
              </div>
              <span className={`sp-badge ${addon.isActive ? 'sp-badge-active' : 'sp-badge-inactive'}`}>
                {addon.isActive ? 'Active' : 'Inactive'}
              </span>
              <button
                type="button"
                className="sp-btn sp-btn-secondary sp-btn-block"
                onClick={() => navigate(`/plan-addons/${addon.id}/edit`)}
              >
                <i className="fa-solid fa-pen-to-square" /> Edit
              </button>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
